module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-counter"
  }, [_c('div', {
    staticClass: "wrapper-number"
  }, _vm._l((_vm.arr), function(number) {
    return _c('div', {
      key: 'number-' + Math.random() + number,
      staticClass: "text-number"
    }, [_vm._v("\n        " + _vm._s(number) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.titile))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99bf222a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advCounter.vue
// module id = 369
// module chunks = 2